import React, { useRef, useState, useEffect } from "react";
import DuoRoundedIcon from "@mui/icons-material/DuoRounded";
import { toast } from "react-toastify";

const UploadVideo = ({ video, setVideo }) => {
  const fileInputRef = useRef(null);

  const [videoUrl, setVideoUrl] = useState(null);
  const [aspectRatio, setAspectRatio] = useState("16 / 9");
  const [isBunnyEmbed, setIsBunnyEmbed] = useState(false);

  useEffect(() => {
    if (!video) {
      setVideoUrl(null);
      setAspectRatio("16 / 9");
      setIsBunnyEmbed(false);
      return;
    }

    if (typeof video === "string") {
      const bunnyEmbed =
        video.includes("iframe.mediadelivery.net/embed/") ||
        video.includes("player.mediadelivery.net/embed/");

      setIsBunnyEmbed(bunnyEmbed);

      if (bunnyEmbed) {
        const hasQuery = video.includes("?");
        const cleanedUrl = video
          .replace(/([?&])autoplay=(true|false)/gi, "")
          .replace(/([?&])preload=(true|false)/gi, "")
          .replace(/[?&]$/, "");

        const separator = cleanedUrl.includes("?") ? "&" : "?";
        setVideoUrl(`${cleanedUrl}${separator}autoplay=false&preload=false`);
      } else {
        setVideoUrl(video);
      }

      return;
    }

    const url = URL.createObjectURL(video);
    setVideoUrl(url);
    setIsBunnyEmbed(false);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [video]);

  const handleFile = (file) => {
    if (!file) return;

    if (!file.type.startsWith("video/")) {
      toast.error("Please upload a video file only.");
      return;
    }

    if ((file?.size / (1024 * 1024)).toFixed(2) > 35) {
      toast.error("Please Upload a Video File less than 35 MB");
      return;
    }

    let vid = document.createElement("video");
    vid.preload = "metadata";

    vid.onloadedmetadata = () => {
      URL.revokeObjectURL(video?.src);

      // Duration in seconds
      // console.log("Duration:", vid.duration);

      if (Math.round(vid.duration) > 120) {
        toast.error("Video Duration must be 2 Mins or less than 2 Mins");
        return;
      }
    };

    vid.onerror = () => {
      console.error("Failed to load video metadata.");
    };

    vid.src = URL.createObjectURL(file);



    setVideo(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      {video && (
        <div className="d-flex justify-content-end gap-2">
          <button
            type="button"
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn bg-primary1"
            onClick={() => fileInputRef.current.click()}
          >
            <DuoRoundedIcon />
            &nbsp; Upload Video
          </button>
        </div>
      )}

      <div
        className="upload-video-container rounded-1 mt-3"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        style={{
          width: "100%",
          aspectRatio: aspectRatio,
          maxWidth: "100%",
          borderRadius: "10px",
          overflow: "hidden",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {video ? (
          isBunnyEmbed ? (
            <iframe
              src={videoUrl}
              title="Bunny Stream Video"
              loading="lazy"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                display: "block",
              }}
            />
          ) : (
            <video
              src={videoUrl}
              controls
              onLoadedMetadata={(e) => {
                const { videoWidth, videoHeight } = e.target;
                if (videoWidth && videoHeight) {
                  setAspectRatio(`${videoWidth} / ${videoHeight}`);
                }
              }}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          )
        ) : (
          <div
            className="text-center"
            style={{
              padding: "20px",
            }}
          >
            <p>Choose a file or drag & drop it here</p>

            <div className="d-flex justify-content-center gap-2 mt-2 flex-wrap">
              <button
                type="button"
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn bg-primary1"
                onClick={() => fileInputRef.current.click()}
              >
                <DuoRoundedIcon />
                &nbsp; Upload Video
              </button>
            </div>
          </div>
        )}

        <input
          ref={fileInputRef}
          type="file"
          accept="video/*"
          style={{ display: "none" }}
          onChange={(e) => handleFile(e.target.files[0])}
        />
      </div>
    </div>
  );
};

export default UploadVideo;
